import { gql } from '@apollo/client';

export const DEACTIVATE_PATIENT = gql`
  mutation DeactivatePatient($record: DeletePatientInput!) {
    user {
      patientUser {
        deletePatient(record: $record) {
          ok
          error {
            message
            code
          }
        }
      }
    }
  }
`;
